import config from "../../util/Config";
import {ProgressAuthMessage, ProgressMessage} from "../../api/Model";
import {webSocket} from "../../util/WebSocket";
import {Lifetime} from "../../util/Lifetime";

export async function* operationWebSocket(lifetime: Lifetime, authToken: string, endpoint: string): AsyncGenerator<ProgressMessage, void> {
    const cnf = await config;

    // Construct the full URL with the optional token
    const fullUrl = `${cnf.webSocketUrl}${endpoint}`;

    const ws = await webSocket({url: fullUrl, lifetime});
    const authMessage: ProgressAuthMessage = {token: authToken};
    ws.send(JSON.stringify(authMessage));

    for await (const message of ws.incoming) {
        try {
            const updateMessage: ProgressMessage = JSON.parse(message);
            yield updateMessage;
        } catch (e) {
            console.warn(`Cannot parse progress message from server: ${message}`);
        }
    }
}